import isHostComponent from '@mui/utils/isHostComponent';
const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !isHostComponent(Slot);
};
export default shouldSpreadAdditionalProps;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/shouldSpreadAdditionalProps.js
// module id = 1813
// module chunks = 22